








































































import { Component } from 'vue-property-decorator';
import SettingMixin from '@/components/ViewComponent/Setting/setting.mixin';

@Component<Password>({})
export default class Password extends SettingMixin {}
